import { render, staticRenderFns } from "./ProjectRealEstateListings.vue?vue&type=template&id=6f19e97b"
import script from "./ProjectRealEstateListings.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstateListings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports